import { DateTime } from 'luxon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faUserSlash } from '@fortawesome/pro-light-svg-icons'

import {
  Box, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'

import type { TaskListModel, UserModel } from '@models/types'

import useUser, { useRelations } from '@hooks/useUser'

interface UserProps {
  taskList: TaskListModel,
  user: UserModel,
}

const User = (props: UserProps) => {
  const { taskList, user } = props

  const userPayload = useUser(user)
  const { user: { full_name } } = userPayload
  const { image } = useRelations(user)

  // @ts-expect-error
  const completionDateString = taskList?.dates?.completed?.date_time

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      disableHover
    >
      <UserProfileImage
        boxProps={{ display: 'inline-flex' }}
        hintComponent={<UserProfileImage.Hint>{user.full_name || 'Unassigned'}</UserProfileImage.Hint>}
        imageUrl={image.thumb_url}
      >
        <FontAwesomeIcon icon={user.id ? faUser : faUserSlash} />
      </UserProfileImage>

      <Box flexDirection="column" marginLeft="large">
        <Text fontSize="small">
          {full_name}
        </Text>

        <Text color="faintGrey" fontSize="xsmall" marginTop="medium">
          {completionDateString
            ? DateTime.fromFormat(completionDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
            : 'Not Set'}
        </Text>
      </Box>
    </ListItem>
  )
}

export default User
